<template>
  <div class="container">
    <div class="left-container" v-if="video">
      <div class="title-bar">
        <span class="video-type">
          <i class="icon icon-live-stream-red" :class="type === 'stream'?'icon-live-stream-red':'icon-video-red'"></i>{{getDict(type === 'stream'?1:9)}}
        </span>
        <span class="video-title"><autoTitle :title="video.title"></autoTitle></span>
        <!-- <span class="video-title">{{ video.title }}</span> -->
        <span class="watch-num">
          <i class="icon icon-watch-people"></i>{{ video.viewCount | readableNum }}
        </span>
        <span class="user-info">
          <span class="user-avatar" :style="{backgroundImage:video.streamerAvatar? `url(${video.streamerAvatar})` : 'none'}"></span><span class="user-name">{{video.streamer}}</span>
          <template v-if="['liveBroadcast'].includes(videoType)">
            <i class="icon" :class="followed?'icon-followed':'icon-follow'" @click="follow"></i>
          </template>
          
        </span>
        <span class="right-ctrl">
          <!-- <span class="like ctrl">
            <i class="icon icon-like" :class="[followed && 'active']"></i>
            <span class="word">666</span>
          </span> -->
          <span class="reward" @click="showReward = true" v-if="['liveBroadcast','tornament'].includes(videoType)">{{getDict(76)}}</span>
        </span>
      </div>
      <player class="video-player" :platform="video.platform" :video-id="video.videoId" />
    </div>
    <div class="right-container" v-if="true && video">
      <tabBar :activeID.sync="activeTab" :tabList="rightBoxCompNameList"></tabBar>
      <div class="comp">
        <RewardBox v-if="showReward" class="float-comp" @close="showReward = false" :channelId="video.channelId"></RewardBox>
        <ChatBox v-if="rightBoxCompShowKeys.includes('chatBox')" v-show="activeTab === 'chatBox'" :video-id="video.videoId"></ChatBox>
        <CommentBox v-if="rightBoxCompShowKeys.includes('commentBox')" v-show="activeTab === 'commentBox'" :video-id="video.videoId"></CommentBox>
        <GambleBox v-if="rightBoxCompShowKeys.includes('gambleBox')" v-show="activeTab === 'gambleBox'" :video-id="video.videoId"></GambleBox>
        
      </div>
      
      
      <!-- 聊天空间占位 -->
    </div>
    <alert ref="alertBox"></alert>
  </div>
</template>

<script>
  import { getQuery, getDict, axios, getPageLevelMixin, webSocket } from '../common'
  import Player from '../components/player'
  import AutoTitle from '../components/autoTitle'
  import { mapState, mapGetters } from 'vuex'
  import TabBar from '../components/tabBar'
  import ChatBox from '../components/chatBox'
  import CommentBox from '../components/commentBox'
  import GambleBox from '../components/gambleBox'
  import RewardBox from '../components/rewardBox'
  import alert from '../components/alert'
  import store from '@/store'

  const rightBoxComp = {
    chatBox:{
      name:getDict(28),
      showPages:['liveBroadcast','tornament'],
    },
    commentBox:{
      name:getDict(29),
      showPages:['video'],
    },
    gambleBox:{
      name:getDict(30),
      showPages:['liveBroadcast','tornament'],
      needLive:true,
    }
  }

  export default {
    name: 'videoPlayer',
    props:{
      videoType:{},
      showTabList:{},
    },
    mixins:[getPageLevelMixin],
    data(){
      return {
        rightBoxComp,
        activeTab:'',
        pageLevel:2,
        video: null,
        followed:false,
        showReward:false,
        showGambleInVideo:getQuery('env') == 'test',
      }
    },
    computed:{
      ...mapState(['userData']),
      type(){
        if(this.video){
          return ['live','upComing','upcoming'].includes(this.video.liveBroadcastContent)?'stream':'video';
        }
        
      },
      rightBoxCompNameList(){
        let list = [];
        for(let key in rightBoxComp){
          if(rightBoxComp[key].showPages.includes(this.videoType)){
            if(rightBoxComp[key].needLive && this.type != 'stream' && !this.showGambleInVideo){
              continue;
            }
            list.push({
              name:rightBoxComp[key].name,
              id:key,
            })
          }
        }
        
        return list;
      },
      rightBoxCompShowKeys(){
        let list = [];
        for(let node of this.rightBoxCompNameList){
          list.push(node.id);
        }
        return list;
      }
    },
    watch:{
      '$route.params.id'(){
        this.getVideoInfo();
      },
      rightBoxCompNameList(){
        this.setActiveTab();
      },
      'userData.userName'(){
        this.updataFollowStatus();
      }
    },
    methods: {
      getDict,
      
      async getVideoInfo(){
        console.log(13)
        if(!this.$route.params.id){
          return;
        }
        let result = await axios.get(`/api/video/${this.$route.params.id}`);
        if(result.status == 200){
          if(result.data){
            this.video = result.data;
          }
        }
        /*if(this.videoType == 'video'){
          let result = await axios.get(`/api/video/${this.$route.params.id}`);
          if(result.status == 200){
            if(result.data){
              this.video = result.data;
            }
          }
          // this.$set(this.video,'followed',false);
        }else if(this.videoType == 'liveBroadcast'){
          // let result = await axios.get(`/api/liveBroadcast/${this.$route.params.id}`);//这个方法后台已经删除代码，先用下面那个代替
          let result = await axios.get(`/api/video/${this.$route.params.id}`);
          if(result.status == 200){
            if(result.data){
              this.video = result.data;
            }
          }
          // this.$set(this.video,'followed',false);
        }*/

        if(['liveBroadcast'].includes(this.videoType)){
          if(this.userData.userName){
            await this.updataFollowStatus()
          }
          
        }
        
        
      },
      setActiveTab(){
        this.activeTab = this.rightBoxCompNameList[0].id;
      },
      async follow(){
        console.log(123)
        try{
          await webSocket.get('/user/follow',{
            channelId: this.video.channelId,
            cancel: this.followed,
          });
        }catch(res){
          if(res.err_msg.indexOf('exceed limit') != -1){
            this.$refs.alertBox.alert(this.getDict(73));
          }
        }
        await this.updataFollowStatus();
      },
      async updataFollowStatus(){
        let isFollow = await webSocket.get('/user/is_follow',{
          channelId: this.video.channelId,
        });
        this.followed = isFollow.yes || false;
      },
      async changeInterSataus(inRoom){
        if(['liveBroadcast','tornament'].includes(this.videoType)){
          await webSocket.get('/live/room/change',{
            room_id: this.video? this.video.videoId : this.$route.params.id,
            leave:!inRoom,
            live:this.type == 'stream'
          });
        }
        
      }
    },
    components: {
      AutoTitle,Player,TabBar,ChatBox,CommentBox,GambleBox,RewardBox,alert
    },
    created(){
      this.getVideoInfo();
      store.commit('setWatchingVideoID',this.$route.params.id);
    },
    mounted(){
      this.setActiveTab();
      this.changeInterSataus(true);
    },
    beforeDestroy(){
      store.commit('setWatchingVideoID',null);
      this.changeInterSataus(false)
    }
  }
</script>

<style lang="scss" scoped>
  .container{
    margin-top: .3rem;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
  .left-container{
    width: 9.6rem;
    margin-right: .2rem;
    overflow: hidden;
    /*display: flex;*/
    /*flex-direction: column;*/
  }
  .title-bar{
    height: .56rem;
    padding: 0 .12rem;
    line-height: .36rem;
    // background: rgba(0, 0, 0, .2);
    background: rgba(40,40,40,1);
    display: flex;
    align-items: center;
    position: relative;
    .video-type{
      color: #c90e0e;
      font-size: .18rem;
      margin-right: .18rem;
    }
    .video-title{
      // color: #232324;
      color: #fff;
      font-size: .22rem;
      // max-width: 1.75rem;
      max-width: 2.5rem;
      // max-width: 4.2rem;
      margin-right: .12rem;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
    }
    .watch-num{
      color: white;
      font-size: .22rem;
      padding-right: .13rem;
      margin-right: .13rem;
      position: relative;
      &:after{
        content: ' ';
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -.115rem;
        width: 1px;
        height: .23rem;
        background: white;
      }
    }
    .user-info{
      color: white;
      font-size: .22rem;
      display: flex;
      align-items: center;
      .user-avatar{
        display: inline-block;
        background: no-repeat center center;
        background-size: 100% 100%;
        width: .38rem;
        height: .38rem;
        border-radius: 50%;
        margin-right: .04rem;
        border: .01rem solid #ecbc5f;;
      }
      .user-name{
        // max-width: 1.2rem;
        max-width: 4rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .icon{
        margin-left: 0.1rem;
      }
    }
    .right-ctrl{
      height: .36rem;
      line-height: .36rem;
      padding: 0 .17rem;
      font-size: .2rem;

      position: absolute;
      right: .12rem;
      top: 50%;
      margin-top: -.18rem;
      display: flex;
      align-items: center;

      .icon{
        width: 0.3rem;
        height: 0.3rem;
      }
      .ctrl{
        display: inline-block;
        height: 0.3rem;
      }

      .like{
        .word{
          float: right;
          height:  0.15rem;
          line-height:  0.15rem;
          font-size: 0.15rem;
          color: #fff;
          .active{
            color: #ffc44f;
          }
        }
      }

      .reward{
        min-width: 1rem;
        padding: 0 0.1rem;
        // margin: 0.2rem auto;
        background: url(../assets/gamble-submit-btn.png) no-repeat center center;
        background-size: 100% 100%;
        $font-size:0.22rem;
        font-size: $font-size;
        line-height: $font-size * 1.8;
        text-align: center;
        color: #000; 

        .lang-jp & {
          $font-size:0.2rem;
          font-size: $font-size;
          line-height: $font-size * 1.8;
        }
        .lang-en & {
        }
      }
      
    }
  }
  .video-player{
    height: 5.4rem;
  }
  .right-container {
    width: 2.8rem;

    .comp{
      
      height: 5.4rem;
      position: relative;
      .float-comp{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 5;
      }
    }
    
  }  

</style>
